import { FC } from 'react';
import cx from 'classnames';

const SkeletonCell: FC<{ width?: string }> = ({ width = 'w-16' }) => (
  <div className="animate-pulse" data-test-id="skeleton-cell">
    <div className={cx('h-4 bg-gray-200 rounded', width)} data-test-id="skeleton-cell-bar" />
  </div>
);

export default SkeletonCell;
